import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

const TipoDocumentoFormGroup = ({ setMostrarRefrescar, setFieldValue, fIsSubmitting, iValue }) => {
  const onChangeFlagRecibo = React.useCallback(
    e => {
      setFieldValue('flagReciboHonorario', e.target.checked)
      setMostrarRefrescar(true)
    },
    [setMostrarRefrescar, setFieldValue]
  )

  return (
    <Row>
      <Col md={12} className='pt-2'>
        <Field name='flagReciboHonorario'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              onChange={e => onChangeFlagRecibo(e)}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagReciboHonorario'
              label='Recibo x Honor'
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoDocumentoFormGroup)
